import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OpportunityComponent} from '@shared/lib/lazy-modules/opportunity/components/opportunity/opportunity.component';

const routes: Routes = [
  {
    path: '',
    component: OpportunityComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  providers: []
})
export class OpportunityRoutingModule {
}

